// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"Hamburger__hamburger___2uvOP colors__primary___6imLg","welcome":"Hamburger__welcome___3_NpW","icon":"Hamburger__icon___1ouks"};